var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBluecross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_1995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.74434 4.99999L9.84586 0.898475C10.0514 0.692928 10.0514 0.359687 9.84586 0.15416C9.64031 -0.0513866 9.30705 -0.0513866 9.10152 0.15416L4.99999 4.25567L0.898475 0.15416C0.692928 -0.0513866 0.359687 -0.0513866 0.15416 0.15416C-0.0513671 0.359706 -0.0513866 0.692948 0.15416 0.898475L4.25568 4.99999L0.15416 9.10151C-0.0513866 9.30705 -0.0513866 9.64029 0.15416 9.84582C0.359706 10.0514 0.692948 10.0513 0.898475 9.84582L4.99999 5.7443L9.10149 9.84582C9.30703 10.0514 9.64029 10.0513 9.84582 9.84582C10.0513 9.64027 10.0513 9.30703 9.84582 9.10151L5.74434 4.99999Z",
    fill: "#076AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_1995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluecross);
export default __webpack_public_path__ + "static/media/bluecross.b5524bf5c1ab53653fb06bdc96dcbee2.svg";
export { ForwardRef as ReactComponent };